import type { ColumnsType } from "@similarweb/pro-logic-components";

import {
    getIndexColumn,
    getTopicColumn,
    VOLUME_COLUMN,
    getKeywordsColumn,
    getClicksChangeGroup,
    applySorting,
} from "./sharedTableColumns";
import type { EnrichedTabs, ITransformedTopicsData } from "./types";

type GetTopicsTableColumnsParams = {
    currentPage: number;
    pageSize: number;
    selectedPageTab: string;
    toggleExpandRow?: (key: number, tabId: EnrichedTabs) => void;
    sortConfig?: { sort: keyof ITransformedTopicsData; asc: boolean };
    totalCount: number;
};

export const getTopicsTableColumns = ({
    currentPage,
    pageSize,
    selectedPageTab,
    toggleExpandRow,
    sortConfig,
    totalCount,
}: GetTopicsTableColumnsParams) => {
    const columns: ColumnsType<ITransformedTopicsData> = [
        getIndexColumn(currentPage, pageSize),
        getTopicColumn(totalCount),
        getKeywordsColumn(toggleExpandRow),
        { ...VOLUME_COLUMN },
        getClicksChangeGroup(toggleExpandRow, selectedPageTab),
    ];

    return sortConfig ? applySorting(columns, sortConfig) : columns;
};
